// eslint-disable-next-line prefer-arrow/prefer-arrow-functions
export function tryRegisterExtensionMethod<Base, T, K extends keyof Base>(target: Base, functionName: K, fn: Base[K]) {
  if (!target[functionName]) {
    target[functionName] = fn;

    if (target === Object.prototype) {
      Object.defineProperty(Object.prototype, functionName, {
        value: fn,
        configurable: true,
        enumerable: false,
        writable: true,
      });
    } else {
      target[functionName] = fn;
    }
  } else {
    // console.error(`failed to register extension method '${functionName}'`);
  }
}
